import React from 'react';
import { ContentItem } from '../../../models/ContentManagementInterface';
import HeroImagePreviewGraphic from './HeroImagePreviewGraphic';
import ImageCardPreviewGraphic from './ImageCardPreviewGraphic';
import LeftRightListPreviewGraphic from './LeftRightListPreviewGraphic';
import SubtitlePreviewGraphic from './SubtitlePreviewGraphic';
import TablePreviewGraphic from './TablePreviewGraphic';
import TextPreviewGraphic from './TextPreviewGraphic';
import TextSectionPreviewGraphic from './TextSectionPreviewGraphic';

export interface PaletteBlockDef {
  /** Content block type this palette entry creates. */
  type: ContentItem['type'];
  /** Human label shown under the preview. */
  label: string;
  /** One-line description of the block. */
  description: string;
  /**
   * Static SVG stand-in for the block, rendered inside
   * {@link MiniatureBlockPreview} (a non-interactive framed thumbnail).
   */
  renderPreview: () => React.ReactNode;
}

/**
 * Registry of blocks available from the left palette. Kept deliberately small
 * for now — Image Cards first — and shared (eventually) by both the content
 * editor and the fund update editor.
 */
export const PALETTE_BLOCKS: PaletteBlockDef[] = [
  {
    type: 'StandardHeaderText',
    label: 'Text Section',
    description: 'A heading with paragraphs of text',
    renderPreview: () => <TextSectionPreviewGraphic />,
  },
  {
    type: 'Subtitle',
    label: 'Subtitle',
    description: 'A heading on its own, to break up a longer page',
    renderPreview: () => <SubtitlePreviewGraphic />,
  },
  {
    type: 'Text',
    label: 'Text',
    description: 'A paragraph of text with no heading',
    renderPreview: () => <TextPreviewGraphic />,
  },
  {
    type: 'ImageCarousel',
    label: 'Image Cards',
    description: 'Images with a title and prose beneath',
    renderPreview: () => <ImageCardPreviewGraphic />,
  },
  {
    type: 'HeroImage',
    label: 'Hero Image',
    description: 'A single image on its own, with no text',
    renderPreview: () => <HeroImagePreviewGraphic />,
  },
  {
    type: 'LeftRightList',
    label: 'Key Details List',
    description: 'Rows of a label and a value',
    renderPreview: () => <LeftRightListPreviewGraphic />,
  },
  {
    type: 'Table',
    label: 'Table',
    description: 'A grid of cells with an optional header row',
    renderPreview: () => <TablePreviewGraphic />,
  },
];
